/**
 * Header bell icon with an unread badge; opens the notification history.
 *
 * Icon-only button matching the existing refresh-button precedent in the
 * dashboard header. Self-contained — it renders its own history modal, so
 * integration at a call site is just <NotificationBell />.
 *
 * The badge is ALWAYS indigo, even when a critical notice is in the stack. It
 * communicates how many, not how bad; the banner already carries severity, and
 * a red badge on a routine announcement would train people to ignore it.
 */

import { useState } from 'react';
import { Bell } from 'lucide-react';
import { useNotifications } from '../hooks/useNotifications';
import NotificationHistoryModal from './NotificationHistoryModal';

export default function NotificationBell() {
  const { unreadCount } = useNotifications();
  const [historyOpen, setHistoryOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setHistoryOpen(true)}
        title="Notifications"
        aria-label={
          unreadCount > 0 ? `Notifications (${unreadCount} unread)` : 'Notifications'
        }
        className="relative p-2 rounded-lg border border-gray-300 hover:bg-gray-100 transition-colors"
      >
        <Bell className="w-5 h-5 text-gray-600" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 grid place-items-center bg-indigo-600 text-white text-[11px] font-semibold rounded-full ring-2 ring-gray-50">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </button>

      <NotificationHistoryModal
        isOpen={historyOpen}
        onClose={() => setHistoryOpen(false)}
      />
    </>
  );
}
